var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 200,
    viewBox: "0 0 500 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332 18C341.941 18 350 9.94113 350 0H464C483.882 0 500 16.1178 500 36V164C500 183.882 483.882 200 464 200H350C350 190.059 341.941 182 332 182C322.059 182 314 190.059 314 200H36C16.1178 200 0 183.882 0 164V36C0 16.1178 16.1177 0 36 0H314C314 9.94113 322.059 18 332 18ZM334 30.7C334 30.1477 333.552 29.7 333 29.7C332.448 29.7 332 30.1477 332 30.7V50.5C332 51.0523 332.448 51.5 333 51.5C333.552 51.5 334 51.0523 334 50.5V30.7ZM334 70.3C334 69.7477 333.552 69.3 333 69.3C332.448 69.3 332 69.7477 332 70.3V90.1C332 90.6523 332.448 91.1 333 91.1C333.552 91.1 334 90.6523 334 90.1V70.3ZM334 109.9C334 109.348 333.552 108.9 333 108.9C332.448 108.9 332 109.348 332 109.9V129.7C332 130.252 332.448 130.7 333 130.7C333.552 130.7 334 130.252 334 129.7V109.9ZM334 149.5C334 148.948 333.552 148.5 333 148.5C332.448 148.5 332 148.948 332 149.5V169.3C332 169.852 332.448 170.3 333 170.3C333.552 170.3 334 169.852 334 169.3V149.5Z",
    fill: "url(#paint0_linear_52_7401)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_7401",
    x1: 500,
    y1: 0.0000372529,
    x2: -0.00000655651,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F8FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryBackground);
export default __webpack_public_path__ + "static/media/summary_background.0715eb5a76e675a6cf8402a993c85dfb.svg";
export { ForwardRef as ReactComponent };